module.exports = __webpack_public_path__ + "static/media/banner_3.384ee273.webp";